import { h, Component } from 'preact'
import { throwError } from 'cerebral'
import { DEPRECATE } from 'cerebral/internal'
import { ControllerContext } from './context'

class Container extends Component {
  // Support for Preact 8
  getChildContext() {
    const { app, controller } = this.props

    if (controller) {
      DEPRECATE(
        'Container',
        'please change from "controller" to "app" property'
      )
    }

    if (!app && !controller) {
      throwError('You are not passing a Cerebral app to Container')
    }

    return { controller: app || controller }
  }

  render(props) {
    const { app, controller, children } = props

    if (controller) {
      DEPRECATE(
        'Container',
        'please change from "controller" to "app" property'
      )
    }

    if (!app && !controller) {
      throwError('You are not passing a Cerebral app to Container')
    }

    const controllerInstance = app || controller

    // Support for Preact 10
    if (ControllerContext && ControllerContext.Provider) {
      return h(
        ControllerContext.Provider,
        { value: controllerInstance },
        children[0] || children
      )
    }

    return children[0] || children
  }
}

export default Container
